import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Chrome-ot használ a user.
 * @param ua - UserAgent.
 */
export default function isChrome (ua: string): boolean {
  return userAgentParser.isChrome(ua)
}
